<template>
  <div class="tr-item-container" :style="{ height: height }">
    <div v-if="imageUrl" class="item-image-container">
      <router-link :to="{ path: `${visitPath}` }" target="_blank">
        <img
          @click="click(item)"
          :src="processImgUrl(imageUrl)"
          :height="height"
          :width="width"
          alt
          :style="{ cursor: 'pointer' }"
        />
      </router-link>
      <div
        class="item-target"
        v-if="showTarget"
        :style="{
          'background-image': `url(${targetUrl})`,
          color: targetTextColor
        }"
      >
        {{ targetText }}
      </div>
    </div>
    <router-link v-else :to="{ path: `${visitPath}` }" target="_blank">
      <div @click="click(item)" class="default-url">
        <div
          class="item-target"
          v-if="showTarget"
          :style="{
            'background-image': `url(${targetUrl})`,
            color: targetTextColor
          }"
        >
          {{ targetText }}
        </div>
      </div>
    </router-link>
    <slot>
      <div clas>item 站位</div>
    </slot>
  </div>
</template>
<script>
import targetUrl from "@/assets/images/travel/new-target.png";
export default {
  props: {
    visitPath: {
      type: String
    },
    imageUrl: {
      type: String
    },
    height: {
      type: String,
      default: "248px"
    },
    width: {
      type: String,
      default: "440px"
    },
    defaultImg: {
      type: String,
      default: ""
    },
    item: {
      type: Object
    },
    showTarget: {
      type: Boolean,
      default: false
    },
    targetUrl: {
      type: String,
      default: targetUrl
    },
    targetText: {
      type: String,
      default: "新"
    },
    targetTextColor: {
      type: String,
      default: "#ffffff"
    }
  },
  methods: {
    processImgUrl(src) {
      if (src.indexOf("upcdn") !== -1 || src.indexOf("upyun") !== -1) {
        return `${src}!/fw/440/fh/248`;
      }
      if (src.indexOf("aliyuncs") !== -1) {
        return `${src}?x-oss-process=image/resize,m_mfit,h_248,w_440`;
      }
      return src;
    },
    click(item) {
      this.$emit("click", { item });
    }
  }
};
</script>
<style lang="less">
.tr-item-container {
  position: relative;
  display: flex;
  justify-content: flex-start;
  &:hover {
    box-shadow: 0px 0px 15px 0px #d2d6df;
  }
  img {
    cursor: pointer;
    flex: none;
  }
  .default-url {
    height: 248px;
    width: 440px;
    background-image: url("~@/assets/images/travel/cover.png");
    background-repeat: no-repeat;
    background-size: auto 248px;
    background-position-x: 78%;
    cursor: pointer;
    flex: none;
  }
  .item-image-container {
    position: relative;
  }
  .item-target {
    position: absolute;
    top: 0;
    left: 19px;
    height: 44px;
    width: 40px;
    font-size: 20px;
    line-height: 37px;
    font-weight: 600;
  }
}
</style>
